import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance } from './AuthProvider';
import { apiTokenRequest } from './msalConfig';

/**
 * Acquires an access token silently. Falls back to redirect if interaction is needed.
 * Used by the Axios interceptor to attach Bearer tokens to API requests.
 */
export async function acquireAccessToken(): Promise<string | null> {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    return null;
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...apiTokenRequest,
      account,
    });
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      // Token expired or consent required — trigger redirect
      await msalInstance.acquireTokenRedirect(apiTokenRequest);
      return null;
    }
    // eslint-disable-next-line no-console
    console.error('[OptiBush Auth] Token acquisition failed:', error);
    return null;
  }
}
